'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '@module/mdrt-org/shared/components/button/button';
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { useGetNullableCustomerProfile } from '@module/mdrt-org/shared/utils/hooks/use-get-nullable-customer-profile';
import { impersonatedPersonIdCookieAction } from '@shared/misc/next-auth/impersonated-person-id-cookie-action';
import { FormInput } from '@shared/ui-components/form-input/form-input';
import { FormWrapper } from '@shared/ui-components/form-wrapper/form-wrapper';
import { ModalTrigger } from '@shared/ui-components/modal/modal';
import { ButtonType } from '@shared/utils/enums/button-type';
import { Dialog } from '../../../dialog/dialog';
import { useUserContext } from '../../../providers/user-context';
import { type HeaderAccountDropdownContent } from '../../graphql/get-header-profile-dropdown-content';
import styles from './impersonation-modal.module.scss';
type ImpersonationFormData = {
  personId: string;
};
export const ImpersonationModal = t0 => {
  const $ = _c(25);
  const {
    cmsContent,
    isOpen,
    onClose
  } = t0;
  const {
    personId,
    personIdBeforeImpersonation,
    updateSession
  } = useUserContext();
  const [loading, setLoading] = useState(false);
  const {
    getNullableCustomerProfile
  } = useGetNullableCustomerProfile();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValues: {
        personId: ""
      },
      mode: "onSubmit"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const formMethods = useForm(t1);
  let t2;
  if ($[1] !== formMethods || $[2] !== onClose) {
    t2 = () => {
      formMethods.reset();
      onClose();
    };
    $[1] = formMethods;
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const closeImpersonationModal = t2;
  let t3;
  if ($[4] !== cmsContent.impersonateModalErrorMessage || $[5] !== cmsContent.impersonateModalInvalidInputFormat || $[6] !== cmsContent.requiredLabel || $[7] !== formMethods || $[8] !== getNullableCustomerProfile || $[9] !== personId || $[10] !== personIdBeforeImpersonation || $[11] !== updateSession) {
    t3 = async formData => {
      setLoading(true);
      if (formData.personId.length === 0) {
        formMethods.setError("personId", {
          message: cmsContent.requiredLabel
        });
        setLoading(false);
        return;
      }
      const newPersonId = Number(formData.personId);
      if (!Number.isInteger(newPersonId) || newPersonId <= 0) {
        formMethods.setError("personId", {
          message: cmsContent.impersonateModalInvalidInputFormat
        });
        setLoading(false);
        return;
      }
      const customerProfile = await getNullableCustomerProfile({
        personId: newPersonId
      });
      if (customerProfile === null) {
        formMethods.setError("personId", {
          message: cmsContent.impersonateModalErrorMessage
        });
        setLoading(false);
        return;
      }
      await impersonatedPersonIdCookieAction(newPersonId === personIdBeforeImpersonation ? undefined : newPersonId);
      await updateSession({
        personId: newPersonId,
        personIdBeforeImpersonation: newPersonId === personIdBeforeImpersonation ? undefined : personIdBeforeImpersonation ?? personId
      });
      location.reload();
    };
    $[4] = cmsContent.impersonateModalErrorMessage;
    $[5] = cmsContent.impersonateModalInvalidInputFormat;
    $[6] = cmsContent.requiredLabel;
    $[7] = formMethods;
    $[8] = getNullableCustomerProfile;
    $[9] = personId;
    $[10] = personIdBeforeImpersonation;
    $[11] = updateSession;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const handleSubmit = t3;
  let t4;
  if ($[13] !== closeImpersonationModal || $[14] !== cmsContent.impersonateModalButtonLabel || $[15] !== cmsContent.impersonateModalDescription || $[16] !== cmsContent.impersonateModalPersonIDLabel || $[17] !== cmsContent.impersonateModalTitle || $[18] !== formMethods || $[19] !== handleSubmit || $[20] !== loading) {
    t4 = () => <Dialog isLoading={loading} onModalClose={closeImpersonationModal} title={cmsContent.impersonateModalTitle}><FormWrapper className={styles["impersonation-form"]} dataTestId="impersonation-form" formMethods={formMethods} onSubmit={handleSubmit}><FieldController label={cmsContent.impersonateModalPersonIDLabel} name="personId"><FormInput /></FieldController><p className={styles["impersonation-form__description"]}>{cmsContent.impersonateModalDescription}</p><div className={styles["impersonation-form__actions"]}><Button type={ButtonType.SUBMIT}>{cmsContent.impersonateModalButtonLabel}</Button></div></FormWrapper></Dialog>;
    $[13] = closeImpersonationModal;
    $[14] = cmsContent.impersonateModalButtonLabel;
    $[15] = cmsContent.impersonateModalDescription;
    $[16] = cmsContent.impersonateModalPersonIDLabel;
    $[17] = cmsContent.impersonateModalTitle;
    $[18] = formMethods;
    $[19] = handleSubmit;
    $[20] = loading;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== isOpen || $[23] !== t4) {
    t5 = <ModalTrigger isOpen={isOpen}>{t4}</ModalTrigger>;
    $[22] = isOpen;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  return t5;
};